import _toConsumableArray from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useState, useEffect } from 'react';
import { BUSINESS_TYPE_FOLDER, DEFAULT_MAP_SETTINGS } from './constants';
import { getGoogleStaticMapsApiKey } from '../../../utils/utilityFunction';
import { APIProvider } from '@vis.gl/react-google-maps';
import { initClusters, CloseSites } from './ClusterComposite';
export var Context = /*#__PURE__*/React.createContext();

/**
 * @typedef {Object} Location
 * @property {Array<number>} cltr - Clusters
 * @property {number} lat - Latitude
 * @property {number} lng - Longitude
 * @property {string} fId - Folder ID
 * @property {string} yId - Yext ID
 * 
 * @typedef {['General Practice'|'Ethos'|'Pet Resorts'|'Equine']} BusinessTypes
 */

/**
 * Get the proper file name by adding the IDs in the correct order at the end.
 * @param {BusinessTypes} businessTypes
 * @return {string} - URL of the JSON file that contains the locations
 */
var getNameFileByBusinessType = function getNameFileByBusinessType(businessTypes) {
  var businessIds = '';
  Object.keys(BUSINESS_TYPE_FOLDER).forEach(function (key) {
    if (businessTypes.includes(BUSINESS_TYPE_FOLDER[key].name)) {
      businessIds += "_".concat(BUSINESS_TYPE_FOLDER[key].folderId);
    }
  });
  if (!businessIds) {
    return;
  }
  return "".concat(process.env.NEXT_PUBLIC_MAP_FILES, "coordinates_locations").concat(businessIds, ".json");
};

/**
 * Fetch locations used for markers and to get the IDs to fetch the location data.
 * @param {BusinessTypes} businessTypes
 * @return {Object} JSON Data
 * (e.g. https://codesguat.z22.web.core.windows.net/map/coordinates_locations_266099_266104_266124_266127.json
)
 */
var fetchData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(businessTypes) {
    var fileName, response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileName = getNameFileByBusinessType(businessTypes);
            _context.prev = 1;
            _context.next = 4;
            return fetch(fileName);
          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();
          case 7:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error('Error fetching data:', _context.t0);
          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));
  return function fetchData(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Fetch data used on info window and side bar.
 * @param {Location} location 
 * @returns {Object} Yext Data
 */
var fetchLocationData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(location) {
    var fileName, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            fileName = "".concat(process.env.NEXT_PUBLIC_MAP_FILES, "sites/").concat(location.yId, ".json");
            _context2.next = 4;
            return fetch(fileName);
          case 4:
            response = _context2.sent;
            _context2.next = 7;
            return response.json();
          case 7:
            return _context2.abrupt("return", _context2.sent);
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](0);
            console.error('Error fetching locations data:', _context2.t0);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 10]]);
  }));
  return function fetchLocationData(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var clustersTree = null;
var closeSites = null;
var MapStateProvider = function MapStateProvider(_ref3) {
  var children = _ref3.children,
    initialData = _ref3.initialData;
  var API_KEY = getGoogleStaticMapsApiKey();
  var businessLineLocations = initialData.businessLineLocations;
  var _useState = useState(false),
    isLoaded = _useState[0],
    setIsLoaded = _useState[1];
  var _useState2 = useState(false),
    isLoadingSideBar = _useState2[0],
    setIsLoadingSideBar = _useState2[1];
  var _useState3 = useState(false),
    isLoadingInfoWindow = _useState3[0],
    setIsLoadingInfoWindow = _useState3[1];
  var _useState4 = useState([]),
    closestLocationsFromCenter = _useState4[0],
    setClosestLocationsFromCenter = _useState4[1];
  var _useState5 = useState([]),
    cachedLocations = _useState5[0],
    setCachedLocations = _useState5[1];
  var _useState6 = useState([]),
    allCoorLocations = _useState6[0],
    setAllCoorLocations = _useState6[1];
  var _useState7 = useState(),
    selectedLocation = _useState7[0],
    setSelectedLocation = _useState7[1];
  var _useState8 = useState(null),
    selectedLocationKey = _useState8[0],
    setSelectedLocationKey = _useState8[1];
  var _useState9 = useState(false),
    reStartMap = _useState9[0],
    setReStartMap = _useState9[1];
  var init = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(allCoorLocations.length !== 0)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              getData(businessLineLocations);
            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function init() {
      return _ref4.apply(this, arguments);
    };
  }();

  /**
   * @param {BusinessTypes} businessTypes
   */
  var getData = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(businessTypes) {
      var data;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setIsLoaded(false);
              setIsLoadingSideBar(true);
              _context4.next = 4;
              return fetchData(businessTypes);
            case 4:
              data = _context4.sent;
              setAllCoorLocations(data === null || data === void 0 ? void 0 : data.s);
              clustersTree = initClusters(data === null || data === void 0 ? void 0 : data.c, data === null || data === void 0 ? void 0 : data.s);
              closeSites = new CloseSites(DEFAULT_MAP_SETTINGS.CENTER.lat, DEFAULT_MAP_SETTINGS.CENTER.lng);
              getFirstClosestLocations();
              setIsLoaded(true);
              setIsLoadingSideBar(false);
            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function getData(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  /**
   * @param {Location[]} locations
   */
  var cacheLocations = function cacheLocations(locations) {
    setCachedLocations(function (prevLocations) {
      var filteredLocations = locations.filter(function (location) {
        return !prevLocations.some(function (prevLocation) {
          var _prevLocation$meta, _location$meta;
          return ((_prevLocation$meta = prevLocation.meta) === null || _prevLocation$meta === void 0 ? void 0 : _prevLocation$meta.id) === ((_location$meta = location.meta) === null || _location$meta === void 0 ? void 0 : _location$meta.id);
        });
      });
      return [].concat(_toConsumableArray(prevLocations), _toConsumableArray(filteredLocations));
    });
  };
  var getLocationFromCache = function getLocationFromCache(location) {
    return cachedLocations.find(function (cachedLocation) {
      var _cachedLocation$meta;
      return ((_cachedLocation$meta = cachedLocation.meta) === null || _cachedLocation$meta === void 0 ? void 0 : _cachedLocation$meta.id) === location.yId;
    });
  };

  /**
   * Used when filtering business types on Filters.js
   * @param {BusinessTypes} businessTypes
   */
  var handleBusinessTypeFilter = function handleBusinessTypeFilter(businessTypes) {
    setClosestLocationsFromCenter([]);
    setSelectedLocation(null);
    setSelectedLocationKey(null);
    getData(businessTypes);
  };

  /**
   * Used on side bar infinite scroll. Fetches more locations data and orders it from closest to the center.
   */
  function getMoreClosestLocations() {
    return _getMoreClosestLocations.apply(this, arguments);
  }
  /**
   * Set selected location. Used on marker click or list item click to display info window data.
   * @param {Location} location
   */
  function _getMoreClosestLocations() {
    _getMoreClosestLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var locationsToFetch, extraLocationsToFetch, fetchedLocations;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (clustersTree) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              setIsLoadingSideBar(true);
              locationsToFetch = clustersTree.getOrderedSitesFromCenter(closeSites);
              if (locationsToFetch.length < 6) {
                extraLocationsToFetch = clustersTree.getOrderedSitesFromCenter(closeSites);
                locationsToFetch = [].concat(_toConsumableArray(locationsToFetch), _toConsumableArray(extraLocationsToFetch));
              }
              _context6.next = 7;
              return Promise.all(locationsToFetch.map(fetchLocationData));
            case 7:
              fetchedLocations = _context6.sent;
              cacheLocations(fetchedLocations);
              setClosestLocationsFromCenter([].concat(_toConsumableArray(closestLocationsFromCenter), _toConsumableArray(fetchedLocations)));
              setIsLoadingSideBar(false);
            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _getMoreClosestLocations.apply(this, arguments);
  }
  function handleSelectLocation(_x4) {
    return _handleSelectLocation.apply(this, arguments);
  }
  /**
   * Get Locations on marker click or side bar location click, to display on SideBar.
   * @param {Location} site
   * @return {Location[]} Array of locations
   */
  function _handleSelectLocation() {
    _handleSelectLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(location) {
      var locationData;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (location) {
                _context7.next = 5;
                break;
              }
              setSelectedLocation(null);
              setSelectedLocationKey(null);
              _context7.next = 19;
              break;
            case 5:
              setIsLoadingSideBar(true);
              setIsLoadingInfoWindow(true);
              setSelectedLocationKey(location.yId);
              getClosestLocationsDataFromSite(location);
              locationData = getLocationFromCache(location);
              _context7.t0 = locationData;
              if (_context7.t0) {
                _context7.next = 15;
                break;
              }
              _context7.next = 14;
              return fetchLocationData(location);
            case 14:
              locationData = _context7.sent;
            case 15:
              setSelectedLocation(locationData);
              cacheLocations([locationData]);
              setIsLoadingSideBar(false);
              setIsLoadingInfoWindow(false);
            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return _handleSelectLocation.apply(this, arguments);
  }
  function getClosestLocationsDataFromSite(_x5) {
    return _getClosestLocationsDataFromSite.apply(this, arguments);
  }
  /**
   * Get locations from the cluster
   * @param {string} clusterIndex - string number
   * @param {Object} recentCloseSites - CloseSites
   * @param {Object} recentCloseSites.center - {lat, lng}
   * @param {Array} recentCloseSites.listStudied
   * @returns {Location[]} Array of locations
   */
  function _getClosestLocationsDataFromSite() {
    _getClosestLocationsDataFromSite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(site) {
      var clusterIndex, closeLocations, firstCluster, nextCloserSites;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              clusterIndex = site.cltr.join('');
              closeSites = new CloseSites(site.lat, site.lng);
              closeLocations = [];
              firstCluster = getSitesFromCluster(clusterIndex, closeSites);
              if (Array.isArray(firstCluster)) {
                closeLocations.push.apply(closeLocations, _toConsumableArray(firstCluster));
              }
              if ((firstCluster === null || firstCluster === void 0 ? void 0 : firstCluster.length) < 2) {
                nextCloserSites = clustersTree.getOrderedSitesFromCenter(closeSites);
                if (Array.isArray(nextCloserSites)) {
                  closeLocations.push.apply(closeLocations, _toConsumableArray(nextCloserSites));
                }
              }
              getCloseLocations(closeLocations);
              return _context8.abrupt("return", closeLocations);
            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _getClosestLocationsDataFromSite.apply(this, arguments);
  }
  var getSitesFromCluster = function getSitesFromCluster(clusterIndex, recentCloseSites) {
    if (!clustersTree) {
      return;
    }
    var firstCluster = clustersTree.getOrderedSitesFromClusterIndexAndCenter(clusterIndex, recentCloseSites);
    return firstCluster;
  };

  /**
   * Get closest locations to the center on first load and on business type filter change.
   */
  function getFirstClosestLocations() {
    return _getFirstClosestLocations.apply(this, arguments);
  }
  /**
   * Get the first cluster on first load.
   */
  function _getFirstClosestLocations() {
    _getFirstClosestLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var locationsToFetch, fetchedLocations;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (clustersTree) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return");
            case 2:
              _context9.prev = 2;
              setIsLoadingSideBar(true);
              locationsToFetch = clustersTree.getThreeClustersOrdered(closeSites);
              _context9.next = 7;
              return Promise.all(locationsToFetch.map(fetchLocationData));
            case 7:
              fetchedLocations = _context9.sent;
              cacheLocations(fetchedLocations);
              setClosestLocationsFromCenter(_toConsumableArray(fetchedLocations));
              setIsLoadingSideBar(false);
              _context9.next = 16;
              break;
            case 13:
              _context9.prev = 13;
              _context9.t0 = _context9["catch"](2);
              console.error('Error fetching locations data:', _context9.t0);
            case 16:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[2, 13]]);
    }));
    return _getFirstClosestLocations.apply(this, arguments);
  }
  var getFirstCluster = function getFirstCluster(recentCloseSites) {
    if (!clustersTree) {
      return;
    }
    var firstCluster = clustersTree.getThreeClustersOrdered(recentCloseSites);
    return firstCluster;
  };

  /**
   * Get locations closest to the center that will be used in the side bar.
   * @param {Location[]} locationsToFetch
   */
  var getCloseLocations = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(locationsToFetch) {
      var fetchedLocations;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (locationsToFetch) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              setIsLoadingSideBar(true);
              _context5.prev = 3;
              _context5.next = 6;
              return Promise.all(locationsToFetch.map(fetchLocationData));
            case 6:
              fetchedLocations = _context5.sent;
              cacheLocations(fetchedLocations);
              setClosestLocationsFromCenter(_toConsumableArray(fetchedLocations));
              _context5.next = 14;
              break;
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](3);
              console.error('Error fetching locations data:', _context5.t0);
            case 14:
              setIsLoadingSideBar(false);
            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 11]]);
    }));
    return function getCloseLocations(_x6) {
      return _ref6.apply(this, arguments);
    };
  }();

  /**
   * Get the cluster from the new center on first load, on map restart or on location search.
   */
  var getFirstClusterFromNewCenter = function getFirstClusterFromNewCenter(lat, lng) {
    closeSites = new CloseSites(lat, lng);
    var firstCluster = getFirstCluster(closeSites);
    getCloseLocations(firstCluster);
    return firstCluster;
  };

  /**
   * Restart the map. It will notify other components when the map is reset.
   */
  var handleReStartMap = function handleReStartMap() {
    setReStartMap(!reStartMap);
  };
  useEffect(function () {
    init();
  }, []);
  return __jsx(Context.Provider, {
    value: {
      isLoaded: isLoaded,
      setIsLoaded: setIsLoaded,
      getData: getData,
      allCoorLocations: allCoorLocations,
      closestLocationsFromCenter: closestLocationsFromCenter,
      getMoreClosestLocations: getMoreClosestLocations,
      isLoadingSideBar: isLoadingSideBar,
      isLoadingInfoWindow: isLoadingInfoWindow,
      getFirstClusterFromNewCenter: getFirstClusterFromNewCenter,
      selectedLocation: selectedLocation,
      handleSelectLocation: handleSelectLocation,
      selectedLocationKey: selectedLocationKey,
      setSelectedLocationKey: setSelectedLocationKey,
      handleBusinessTypeFilter: handleBusinessTypeFilter,
      handleReStartMap: handleReStartMap,
      reStartMap: reStartMap
    }
  }, __jsx(APIProvider, {
    apiKey: API_KEY
  }, children));
};
export default MapStateProvider;